<template>
  <div>
    <doughnut-chart
      v-if="dataCollection"
      :data="dataCollection"
      :options="options"
      :height="height"
    ></doughnut-chart>
  </div>
</template>
<script>
import DoughnutChart from "../common/DoughnutChart.js";

export default {
  name: "PollChart",

  components: {
    DoughnutChart
  },
  props: {
    //высота
    height: {
      type: Number,
      default: 200
    },
    // данные для построения графика
    graphData: {
      type: Array,
      default: function() {
        return [{ name: "Нет заполненых ответов", value: 0 }];
      }
    }
  },
  data: () => ({
    // настройки отображения диаграммы
    emptydataCollection: {
      datasets: [
        {
          borderWidth: 0,
          backgroundColor: ["#D8EDFF"],
          data: [1]
        }
      ],
      labels: ["Нет данных"]
    },
    emptydataOptions: {
      cutoutPercentage: 35,
      tooltips: { enabled: false },
      hover: { mode: null },
      legend: {
        display: false
      }
    },
    // данные и подписи для диаграммы
    dataCollection: {},
    options: {
      cutoutPercentage: 35,
      legend: {
        display: false
      }
    }
  }),
  mounted() {
    // таймаут для обработки данных построения диаграммы
    setTimeout(() => {
      if (this.graphData.length === 1 && this.graphData[0].value === 0) {
        this.dataCollection = this.emptydataCollection;
        this.options = this.emptydataOptions;
      } else {
        this.dataCollection = {
          datasets: [
            {
              borderWidth: 0,
              backgroundColor: this.graphData.map(item => item.bg_color),
              data: this.graphData.map(item => item.value)
            }
          ],
          labels: this.graphData.map(item => item.name)
        };
      }
    }, 1000);
  },
  methods: {}
};
</script>
